const laboGrupoInitialState = {
    laboGrupo: {
      loading: false,
      error: null,
      data: null,
      centros: null,
    },
  };
  
  export default laboGrupoInitialState;